import { Intent } from 'signup-constants/Intent';
import { getFlowKey } from '../routing/getFlowKey';
import { getIntentKey } from '../routing/getIntentKey';
import { getIsMobile } from '../utils/deviceUtils';
import { Step } from '../views/Step';
import { FlowConfigRecord } from './FlowConfig';
export const getPostAccountCreationStepsFlowConfig = flowConfig => {
  let postAccountCreationSteps = flowConfig.getFlowSteps().postAccountCreation;
  const intentKey = getIntentKey();

  if (flowConfig.shouldAddHubInterestStep()) {
    postAccountCreationSteps = postAccountCreationSteps.concat([Step.HubInterest]);
  }

  if (flowConfig.showMobileAppPrompt && getIsMobile() && intentKey !== Intent.campaignAssistant) {
    postAccountCreationSteps = postAccountCreationSteps.concat([Step.MobileAppPrompt]);
  }

  return postAccountCreationSteps;
};
export const getFlowConfig = () => {
  const flowKey = getFlowKey();
  const flowConfig = FlowConfigRecord[flowKey];

  if (!flowConfig) {
    throw new Error(`Invalid flow with key ${flowKey}.`);
  }

  return flowConfig;
};
export const getFlowSteps = () => {
  const flowConfig = getFlowConfig();
  const {
    preVerification,
    postExistingAccountSelection,
    postVerification
  } = flowConfig.getFlowSteps();
  return {
    preVerification,
    postVerification,
    postExistingAccountSelection,
    postAccountCreation: getPostAccountCreationStepsFlowConfig(flowConfig)
  };
};